// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconArrowsArrowOutlineActuallyCentredRight_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.46969 3.9991L2 1.52941L3.06066 0.46875L6.59101 3.9991L3.06071 7.52941L2.00005 6.46875L4.46969 3.9991Z" class="svg-bg"/>
</svg>
`;
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.3796 6.03035L3.40991 3.06066L4.47057 2L8.50093 6.03036L4.47057 10.0607L3.40992 9L6.3796 6.03035Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.17279 8.00009L3.87988 2.70718L5.2941 1.29297L12.0012 8.00009L5.2941 14.7072L3.87988 13.293L9.17279 8.00009Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4662 11.9991L5.8501 3.383L7.61786 1.61523L18.0018 11.9991L7.61786 22.383L5.8501 20.6153L14.4662 11.9991Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0001 16.0001L9.93944 1.93945L7.81812 4.06077L19.7575 16.0001L7.81812 27.9395L9.93944 30.0608L24.0001 16.0001Z" class="svg-bg"/>
</svg>
`;
/**
 * IconArrowsArrowOutlineActuallyCentredRight is a generated icon component.
 */
let IconArrowsArrowOutlineActuallyCentredRight = IconArrowsArrowOutlineActuallyCentredRight_1 = class IconArrowsArrowOutlineActuallyCentredRight extends IconBaseElement {
    render() {
        return html `${IconArrowsArrowOutlineActuallyCentredRight_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconArrowsArrowOutlineActuallyCentredRight.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconArrowsArrowOutlineActuallyCentredRight = IconArrowsArrowOutlineActuallyCentredRight_1 = __decorate([
    customElement('zui-icon-arrows-arrow-outline-actually-centred-right')
], IconArrowsArrowOutlineActuallyCentredRight);
export { IconArrowsArrowOutlineActuallyCentredRight };
